import type {
  VendorUser,
  VendorUserSelfUpdateParam,
  VendorUserSettingParam,
  VendorUserUpdatePasswordParam
} from '~/models/VendorUser';
import type { NskResponse } from '~/models/Api';
import {
  deleteRequest,
  postRequest,
  putRequest
} from '~/utils/api/api_handler';

const paths = {
  create: '/vendors/vendor_users',
  update: '/vendors/vendor_users/:id',
  destroy: '/vendors/vendor_users/:id',
  updateSeq: '/vendors/vendor_users/update_seq',
  updateSelf: '/vendors/vendor_users/update_self',
  changePassword: '/vendors/vendor_users/change_password'
};

export const create = async (
  vendorUser: VendorUserSettingParam
): Promise<NskResponse<void>> => postRequest(paths.create, { vendorUser });

export const update = async (
  vendorUser: VendorUserSettingParam,
  vendorUserId: number
): Promise<NskResponse<void>> =>
  putRequest(paths.update.replace(':id', String(vendorUserId)), { vendorUser });

export const destroy = async (
  vendorUserId: number
): Promise<NskResponse<void>> =>
  deleteRequest(paths.destroy.replace(':id', String(vendorUserId)));

export const updateSelf = async (
  vendorUser: VendorUserSelfUpdateParam
): Promise<NskResponse<void>> => putRequest(paths.updateSelf, { vendorUser });

export const changePassword = async (
  passwords: VendorUserUpdatePasswordParam
): Promise<NskResponse<void>> => postRequest(paths.changePassword, passwords);

export const updateSeq = async (
  vendorUsers: VendorUser[]
): Promise<NskResponse<void>> => postRequest(paths.updateSeq, { vendorUsers });
